
import { mapGetters } from "vuex";
import appConfig from "../../appconfig";
import * as Util from "../../libraries/utils";
import VouchersProvider from "../../providers/VouchersProvider";
import ProductProvider from "../../providers/ProductProvider";
import VoucherCartDialogGt2 from "../../components/ShopComponents/gt2/Dialogs/VoucherCartDialog-gt2.vue";
import VoucherLandingPageDialogGt2 from "../../components/ShopComponents/gt2/Dialogs/VoucherLandingPageDialog-gt2.vue";
import VoucherCatalogDialogGt3 from "../../components/ShopComponents/gt3/Dialogs/VoucherCatalogDialog-gt3.vue";

const TimeBox = appConfig.timeBoxImpl.timebox;
const TimeBoxFormats = appConfig.timeBoxImpl.Formats;

export default {
	data() {
		return {
			awardDialog: {
				show: false,
				onClose: () => this.awardDialog.show = false
			},
			availableVouchersData: [],
			product: null,
			awardVoucherItem: null
		};
	},
	components: {VoucherCartDialogGt2, VoucherLandingPageDialogGt2, VoucherCatalogDialogGt3},
	computed: {
		...mapGetters(["applicationUserLoggedIn", "userCrmVouchers"]),
		isAtLeastOneDiscountAppliedToCartSelection() {
			const ids = this.availableVouchersData.map(x=>x.voucherId);
			const psWithVouchers = this.cartProducts.filter(x=>x.voucherId);
			return psWithVouchers.find(x => ids.includes(x.voucherId));
		}
	},
	methods: {
		getProductImage(product) {
			return Util.getBackImages(product).slice(0, 1);
		},
		async getVouchersData() {
			const self = this;
			if(!self.$store.getters.featureToggles.enableDiscountsPage || !self.applicationUserLoggedIn) {
				return [];
			}
			if (self.availableVouchersData.length) {
				return self.availableVouchersData;
			}
			const userVouchers = await VouchersProvider.getUserVouchers();
			self.availableVouchersData.push(...self.getAvailableVouchers(userVouchers.vouchers || []));
			return self.availableVouchersData;
		},
		// called on landingpage-gt2
		async showAwardDialogIfThereAreNewVouchers() {
			const self = this;
			self.awardVoucherItem = (await self.getVouchersData()).find(x => !self.userCrmVouchers.includes(x.id) && !x.usedAt);
			if(self.awardVoucherItem) {
				const products = await ProductProvider.getProducts({productIds: self.awardVoucherItem.productPattern});
				if(products && products.length > 0) {
					self.product = products[0];
				}
				self.awardDialog.show = true;
				self.$store.commit("SET_USER_CRM_USED_VOUCHERS", self.userCrmVouchers.concat(self.awardVoucherItem.id));
			}
		},
		getDialogData() {
			const self = this;
			return {
				show: self.awardDialog.show,
				onClose: self.awardDialog.onClose,
				vouchersData: self.availableVouchersData,
				product: self.product,
				awardVoucherItem: self.awardVoucherItem,
				getProductImage: self.getProductImage
			};
		},


		// gt3 product catalog part
		async showAwardDialogIfThereAreNewVouchersGt3({voucherIds = []}) {
			const self = this;
			self.awardVoucherItem = (await self.getVouchersData()).find(x => {
				return !self.userCrmVouchers.includes(x.id) && !x.usedAt && !voucherIds.includes(x.voucherId);
			});
			if(this.awardVoucherItem) {
				self.product = self.$store.getters.productCatalog.getProduct(this.awardVoucherItem.productPattern[0]);
				const isProductAvailable = Util.canBePickedUp(
					self.product,
					self.$store.getters.productCatalog,
					self.cachedPickupRules,
					self.globalSelectedShop.id
				);
				if(isProductAvailable) {
					self.awardDialog.show = true;
					self.$store.commit("SET_USER_CRM_USED_VOUCHERS", self.userCrmVouchers.concat(self.awardVoucherItem.id));
				}
			}
		},

		getAvailableVouchers(vouchersData) {			
			const filterProductsWhichAreNotInProductCatalog = (item) => {
				if (!this.$store.getters.productCatalog) {
					return true;
				}
				const productId = ((vouchersData.find(x => x.productPattern[0] === item.productPattern[0]) || {}).productPattern || [])[0];
				return productId ? this.$store.getters.productCatalog.productMap[productId] : false;
			};
			return vouchersData.filter(x => !(x.usedAt || TimeBox.fromISO(x.expiryDate).format(TimeBoxFormats.YYYY_MM_DD).exec() < TimeBox.now().format(TimeBoxFormats.YYYY_MM_DD).exec()) && filterProductsWhichAreNotInProductCatalog(x));
		}
	}
};